// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"b55ce06f","245":"c625a8ff","453":"1c95ac1b","569":"dbd1aa35","632":"e7cb0762","950":"8ec5661b","983":"6bff9f0b"}[chunkId] + ".chunk.js";
};